import { render } from "./Liabilities.vue?vue&type=template&id=206717f6&scoped=true"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"

import "./Liabilities.vue?vue&type=style&index=0&id=206717f6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206717f6"]])

export default __exports__